/* @flow */

const mapUnion = <T, U>(map: Map<T, U>, otherMap: Map<T, U>) => {
  for (const item of otherMap) {
    map.set(...item);
  }
};

export { mapUnion };
